/* eslint-disable */
import React, { ComponentType, forwardRef } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { TransitionProps } from "@material-ui/core/transitions";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { CustomWaivedBenifitDialogPropTypes } from "../../../../@types/components/customWaivedBenifitDialogProps.types";
import { Actions, CustomWaivedInputFields } from "../../../../@types/waivedBenifits.types";
import {
	Button,
	TextField,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Slide,
	Grid,
	Select,
	MenuItem,
	IconButton
} from "@material-ui/core";
import "date-fns";

import EventIcon from "@material-ui/icons/Event";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import CloseIcon from "@material-ui/icons/Close";

import "./customWaivedBenifitDialog.scss";

const Transition: ComponentType<TransitionProps & { children?: React.ReactElement<any, any> | undefined }> = forwardRef(
	function Transition(props, ref) {
		return <Slide direction="up" ref={ref} {...props} />;
	}
);

const CustomWaivedBenifitDialog = ({
	waivedDetails,
	dialogProps,
	handleTerminationDateChange,
	handleTerminationReasonChange,
	waivedValidation,
	handleCloseCustomWaivedDialogClick,
	handleApproveWaivedEnrollmentClick,
	currentEnrollment
}: CustomWaivedBenifitDialogPropTypes) => {
	const { openDialog, title, inputFields, actions } = dialogProps;

	return (
		<div>
			<Dialog
				fullWidth
				style={{ zIndex: 800 }}
				open={openDialog}
				onClose={handleCloseCustomWaivedDialogClick}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="form-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="form-dialog-title">
					<div className="custom-dialog-title">
						<span>{title}</span>
						<span>
							<IconButton aria-label="close" onClick={handleCloseCustomWaivedDialogClick}>
								<CloseIcon fontSize="small" />
							</IconButton>
						</span>
					</div>
				</DialogTitle>
				<DialogContent>
					{currentEnrollment.map((textField, index) => {
						const { label, value } = textField;

						return (
							<>
								<Grid container spacing={1} className=" pf-grid-container " key={index}>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<Grid container spacing={1} className="grid-label-style">
											<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
												<div className="label-style">{label}</div>
											</Grid>
											<Grid item xs={9} sm={9} md={8} lg={8} xl={8}>
												<div className="label-value">
													<>{value}</>
												</div>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</>
						);
					})}
				</DialogContent>
				<DialogContent>
					{inputFields.map((textField: CustomWaivedInputFields, index: number) => {
						const { label, placeholder, name, type, value } = textField;

						return (
							<>
								<Grid container spacing={1} className=" pf-grid-container " key={index}>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<Grid container spacing={1} className="pf-label">
											<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
												<div className="pf-label-text required">{label}</div>
											</Grid>
											<Grid item xs={9} sm={9} md={8} lg={8} xl={8}>
												{type === "date" ? (
													<MuiPickersUtilsProvider utils={DateFnsUtils}>
														<KeyboardDatePicker
															className="from-date-input date-input"
															id="from-date-input"
															inputVariant="outlined"
															placeholder={placeholder}
															name={name}
															label={label}
															format="MM/dd/yyyy"
															error={false}
															value={value || null}
															onChange={(_date: any) =>
																handleTerminationDateChange(_date, name)
															}
															InputProps={{
																readOnly: true
															}}
															InputLabelProps={{
																shrink: true
															}}
															keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
															KeyboardButtonProps={{
																"aria-label": "change date"
															}}
															style={{
																pointerEvents: "unset",
																width: "350px",
																borderRadius: 50
															}}
															helperText={
																waivedValidation?.waivedDetails["termination_date"]
															}
														/>
													</MuiPickersUtilsProvider>
												) : type === "textfield" ? (
													<TextField
														className="text-field required"
														id="first-name-input"
														placeholder={placeholder}
														value={value}
														name={name}
														onChange={handleTerminationReasonChange}
														variant="outlined"
														style={{
															pointerEvents: "unset",
															width: "340px",
															borderRadius: 50
														}}
													/>
												) : type === "select" ? (
													<TextField
														value="Member Waived"
														variant="standard"
														InputProps={{
															disableUnderline: true
														}}
														style={{ marginTop: "5px" }}
													/>
												) : null}
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</>
						);
					})}
				</DialogContent>
				<DialogActions className="custom-dialog-actions-button-container">
					{actions.map((action: Actions, index: number) => {
						const { label, callback, name } = action;

						return (
							<Button
								className={
									name === "approve"
										? "custom-dialog-action-button-green"
										: "custom-dialog-action-button-red"
								}
								variant="contained"
								key={index}
								onClick={
									name === "approve"
										? () => handleApproveWaivedEnrollmentClick(true, waivedDetails)
										: name === "reject"
											? () => handleApproveWaivedEnrollmentClick(false, waivedDetails)
											: callback
								}
							>
								<span className="custom-dialog-action-button-label-with-icon">{label}</span>
								<span>
									{name === "approve" ? (
										<DoneAllIcon className="custom-dialog-action-button-icon" />
									) : (
										<CloseIcon className="custom-dialog-action-button-icon" />
									)}
								</span>
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default CustomWaivedBenifitDialog;
